import store from "../store"
import { currencyFormat } from "../functions"

export default {
  data() {
    return {
      loadingOrderSummary: false,
      shippingMethodName: null,
      applyingCoupon: false,
      couponCode: null,
      couponError: null,
      applyingSalesCoupon: false,
      salesCouponCode: null,
      salesCouponError: null,
      anonymous: false,
      redeemedPoints: 0,
      redeemError: null,
      redeemingPoints: false,
      redeemedUsePoints: 0,
      paymentModalMessage: "",
      selectedPayment: null,
      currencyFormat,

      paymentsClient: null
    }
  },

  computed: {
    purchaseLimitProductIDs() {
      const urlParams = new URLSearchParams(window.location.search)

      // Get the value of the 'purchaseLimitProductIDs' parameter as an array
      return urlParams.getAll("purchaseLimitProductIDs[]").map((item) => +item)
    },

    cart() {
      return store.state.cart
    },

    sortedCart() {
      const matchedItems = []
      const remainingItems = []

      Object.entries(this.cart.items).forEach(([property, value]) => {
        if (this.purchaseLimitProductIDs.includes(value.product.id)) {
          matchedItems.push(value)
        }
        if (!this.purchaseLimitProductIDs.includes(value.product.id)) {
          remainingItems.push(value)
        }
      })

      return matchedItems.concat(remainingItems)
    },

    cartIsEmpty() {
      return store.cartIsEmpty()
    },

    cartIsNotEmpty() {
      return !store.cartIsEmpty()
    },

    hasShippingMethod() {
      return store.hasShippingMethod()
    },

    firstShippingMethod() {
      return Object.keys(store.state.cart.availableShippingMethods)[0]
    },

    hasCoupon() {
      return store.state.cart.coupon.code !== undefined
    },

    hasSalesCoupon() {
      return store.state.cart.sales_coupon.code !== undefined
    },

    checkGooglePayButtonDisabledState() {
      return (!this.form?.card_id && !this.form?.new_card && (this.notZeroTotal() && this.requireCard()))
        || !this.form.terms_and_conditions
        || this.cart.zipCodeError !== ""
        || !this.form.shipping_method
        || (!this.form.payment_method && this.notZeroTotal())
        || !_.isEmpty(this.errors.errors)
        || !_.isEmpty(this.billingErrors.errors)
    }
  },

  methods: {
    applySalesCoupon() {
      if (!this.salesCouponCode) {
        return
      }

      this.loadingOrderSummary = true
      this.applyingSalesCoupon = true

      $.ajax({
        method: "POST",
        url: route("cart.coupon.store", { coupon: this.salesCouponCode, type: "sales_coupon" })
      }).then((cart) => {
        this.salesCouponCode = null

        store.updateCart(cart)
      }).catch((xhr) => {
        this.salesCouponError = xhr.responseJSON.message
      }).always(() => {
        this.loadingOrderSummary = false
        this.applyingSalesCoupon = false
      })
    },

    checkSalesCouponOwner(adminId) {
      if (adminId == null || this.cart.sales_man_id == null)
        return true
      return this.cart.sales_man_id == adminId
    },
    removeSalesCoupon() {
      this.loadingOrderSummary = true

      $.ajax({
        method: "DELETE",
        url: route("cart.coupon.destroy", { type: "sales_coupon" })
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },

    redeemPoints() {
      if (!this.redeemedPoints) {
        return
      }

      this.loadingOrderSummary = true
      this.redeemingPoints = true

      $.ajax({
        method: "POST",
        url: route("cart.points.store", { points: this.redeemedPoints })
      }).then((cart) => {
        this.redeemedUsePoints = this.redeemedPoints
        this.redeemedPoints = null

        store.updateCart(cart)
      }).catch((xhr) => {
        this.redeemError = xhr.responseJSON.message
      }).always(() => {
        this.loadingOrderSummary = false
        this.redeemingPoints = false
      })
    },
    applyCoupon() {
      if (!this.couponCode) {
        return
      }

      this.loadingOrderSummary = true
      this.applyingCoupon = true

      $.ajax({
        method: "POST",
        url: route("cart.coupon.store", { coupon: this.couponCode })
      }).then((cart) => {
        this.couponCode = null

        store.updateCart(cart)
      }).catch((xhr) => {
        this.couponError = xhr.responseJSON.message
      }).always(() => {
        this.loadingOrderSummary = false
        this.applyingCoupon = false
      })
    },
    removeCoupon() {
      this.loadingOrderSummary = true

      $.ajax({
        method: "DELETE",
        url: route("cart.coupon.destroy")
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },
    updateShippingMethod(shippingMethod) {
      if (!shippingMethod) {
        return
      }

      this.loadingOrderSummary = true

      this.changeShippingMethod(shippingMethod)

      $.ajax({
        method: "POST",
        url: route("cart.shipping_method.store", { shipping_method: shippingMethod })
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },
    changeShippingMethod(shippingMethodName) {
      this.$set(this.form, "shipping_method", shippingMethodName)
    },

    updatePaymentMethod(paymentMethod) {
      if (!paymentMethod) return

      this.savePayment(paymentMethod)

      if (paymentMethod.discount_percentage != 0) {
        setTimeout(() => {
          this.selectedPayment = paymentMethod
          this.paymentModalMessage = "(Great choice! By selecting " + paymentMethod.vendors + " as your payment method, you'll enjoy a " + (paymentMethod.discount_percentage * 100) + "% discount on your order. Your final total will be reflected at checkout.)"
          this.$bvModal.show("payment-modal")
        }, 500)
      }
    },
    savePaymentMethod() {
      this.$bvModal.hide("payment-modal")
    },
    savePayment(paymentMethod) {
      this.loadingOrderSummary = true

      this.changePaymentMethod(paymentMethod.id)

      $.ajax({
        method: "POST",
        url: route("cart.payment_method.store", { payment_method: paymentMethod.id })
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },
    changePaymentMethod(paymentMethodName) {
      this.$set(this.form, "payment_method", paymentMethodName)
    },

    hasTaps() {
      for (const key in this.cart.items) {
        if (this.cart.items[key].product.type == "100T+")
          return true
      }
      return false
    },

    setPaymentToken(token) {
      this.$set(this.form, "payment_token", token)
    },

    // Google Pay Stuff
    isGooglePay() {
      return this.cart.paymentMethodName && this.cart.paymentMethodName === "google"
    },
    getGooglePaymentsClient() {
      if (this.paymentsClient === null) {
        this.paymentsClient = new google.payments.api.PaymentsClient({
          environment: process.env.googlePayEnvironment,
          paymentDataCallbacks: {
            onPaymentAuthorized: this.onPaymentAuthorized
          }
        })
      }
      return this.paymentsClient
    },
    onGooglePayLoaded() {
      let that = this
      const paymentsClient = this.getGooglePaymentsClient()
      paymentsClient.isReadyToPay(
        // getGoogleIsReadyToPayRequest
        Object.assign({}, { apiVersion: 2, apiVersionMinor: 0 },
          {
            allowedPaymentMethods: [{
              type: "CARD",
              parameters: {
                allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                allowedCardNetworks: ["MASTERCARD", "VISA"],
                billingAddressRequired: false
              }
            }]
          }
        )
      ).then(function(response) {
        if (response.result) {
          that.addGooglePayButton()
        }
      }).catch(function(err) {
        // show error in developer console for debugging
        console.error(err)
      })
    },
    addGooglePayButton() {
      const paymentsClient = this.getGooglePaymentsClient()
      const button = paymentsClient.createButton({
        buttonColor: "default",
        buttonType: "order",
        buttonRadius: 3,
        buttonLocale: "en",
        buttonSizeMode: "fill",
        onClick: this.onGooglePaymentButtonClicked
      })

      // Access the button inside the div
      this.checkGooglePayButtonChangeableProperties(button.querySelector("button"))

      document.getElementById("google-pay-container").appendChild(button)
    },
    checkGooglePayButtonChangeableProperties(googleButton) {
      if (this.checkGooglePayButtonDisabledState) {
        googleButton.setAttribute("disabled", "")
        googleButton.style.cssText += "opacity:0.65"
      } else {
        googleButton.removeAttribute("disabled")
        googleButton.style.removeProperty("opacity")
      }
    },
    onGooglePaymentButtonClicked() {
      const paymentDataRequest = this.getGooglePaymentDataRequest()
      const paymentsClient = this.getGooglePaymentsClient()
      paymentsClient.loadPaymentData(paymentDataRequest)
    },
    getGooglePaymentDataRequest() {
      const paymentDataRequest = Object.assign(
        {},
        {
          apiVersion: 2,
          apiVersionMinor: 0
        }
      )
      paymentDataRequest.allowedPaymentMethods = [
        Object.assign(
          {},
          {
            type: "CARD",
            parameters: {
              allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
              allowedCardNetworks: ["MASTERCARD", "VISA"],
              billingAddressRequired: false
            }
          },
          {
            tokenizationSpecification: {
              type: "PAYMENT_GATEWAY",
              parameters: {
                gateway: process.env.googlePayGateway,
                gatewayMerchantId: process.env.googlePayGatewayMerchantId
              }
            }
          }
        )
      ]
      paymentDataRequest.transactionInfo = {
        currencyCode: "USD",
        totalPriceStatus: "FINAL",
        totalPrice: (this.cart.total.amount).toString()
      }
      paymentDataRequest.merchantInfo = {
        merchantId: process.env.googlePayMerchantId,
        merchantName: process.env.googlePayMerchantName
      }
      paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"]

      return paymentDataRequest
    },
    onPaymentAuthorized(paymentData) {
      const paymentToken64 = btoa(paymentData.paymentMethodData.tokenizationData.token)
      this.setPaymentToken(paymentToken64)
      this.$bvModal.show("confirm-checkout-modal")
    },

    // Apple Pay Stuff
    isApplePay() {
      return this.cart.paymentMethodName && this.cart.paymentMethodName === "apple"
    },
    payWithApplePay() {
      if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
        try {
          let paymentRequest = {
            "merchantCapabilities": ["supports3DS"],
            "supportedNetworks": ["visa", "masterCard"],
            "countryCode": "US",
            "currencyCode": "USD",
            "total": {
              "label": "100Trillion",
              "type": "final",
              "amount": (this.cart.total.amount).toFixed(2).toString()
            }
          }

          const session = new ApplePaySession(3, paymentRequest)

          session.onvalidatemerchant = async (event) => {
            const merchantSession = await this.validateMerchant(event.validationURL, session)
            session.completeMerchantValidation(merchantSession)
          }

          session.onpaymentauthorized = async (event) => {
            const paymentToken64 = btoa(JSON.stringify(event.payment.token.paymentData))
            this.setPaymentToken(paymentToken64)
            this.$bvModal.show("confirm-checkout-modal")
            session.completePayment(ApplePaySession.STATUS_SUCCESS)
          }

          session.begin()
        } catch (error) {
          console.error("Apple Pay error:", error)
        }
      } else {
        alert("Apple Pay is not supported on this browser. Please try other payment method or switch to Safari for Apple Pay!")
      }
    },
    async validateMerchant(validationURL, session) {
      return new Promise((resolve, reject) => {
        $.ajax({
          method: "POST",
          url: route("payment_methods.validate_merchant"),
          contentType: "application/json",
          data: JSON.stringify({ "validationURL": validationURL }),
          dataType: "json",
          success: (response) => {
            resolve(response)
          },
          error: (xhr) => {
            this.$errorNotify(xhr.responseJSON.message)
            reject(new Error(xhr.responseJSON.message))
          }
        })
      })
    }
  },

  mounted() {
    if (this.isGooglePay()) this.onGooglePayLoaded()
  },

  watch: {
    "cart.paymentMethodName": {
      handler(newValue) {
        const googleButton = document.getElementById("gpay-button-online-api-id")

        if (this.isGooglePay()) {
          if (googleButton) {
            googleButton.removeAttribute("hidden")
            this.checkGooglePayButtonChangeableProperties(googleButton)
          } else this.onGooglePayLoaded()
        } else if (googleButton) googleButton.setAttribute("hidden", "")
      }
    },
    checkGooglePayButtonDisabledState(newValue) {
      if (this.isGooglePay()) {
        let googleButton = document.getElementById("gpay-button-online-api-id")
        if (googleButton) this.checkGooglePayButtonChangeableProperties(googleButton)
      }
    }
  }
}
